import Mock from '@/mocks/Mock'
import AlertHistories from '@/models/AlertHistories'
import { AlertHistoryAttributes } from '@/models/AlertHistory'
import { AlertHistoryParams } from '@/repositories/alert-history-repository'

export default class HistoryMock extends Mock<AlertHistoryAttributes[]> {
  constructor() {
    super('alert_history')
  }

  get(params: AlertHistoryParams) {
    console.log(params)

    return new AlertHistories(this.data)
  }
}
